// src/data/users.js
const users = [
  { id: 1, name: "Davi", rate: 24, extra: 0, contact: "+1 (510) 695 6140", contact_url_safe: "15106956140" },
  { id: 2, name: "Vicente", rate: 20, extra: 0, contact: "+1 (510) 706-5269", contact_url_safe: "15107065269" },
  { id: 3, name: "Willians Martins", rate: 20, extra: 20, contact: "+1 (408) 469-3124", contact_url_safe: "14084693124" },
  { id: 4, name: "Roni", rate: 17, extra: 0, contact: "+55 62 8503-7548", contact_url_safe: "556285037548" },
  { id: 5, name: "Luis Angel", rate: 19, extra: 0, contact: "+1 (408) 690-2637", contact_url_safe: "14086902637" },
  { id: 0, name: "Admin", rate: 0, extra: 0, contact: "", contact_url_safe: "" },
];

export default users;
